export default __webpack_public_path__ + "media/images/amenities/shampoo-2486cf3fc8c72a3d809b78fc5c71fb7e.jpeg";